import React, { useRef } from "react";

function ScoreGuide({ items = [], onSubmit }) {
	const minRef = useRef();
	const maxRef = useRef();
	const descRef = useRef();
	const labelRef = useRef();
	return (
		<div className="row">
			<div className="col-md-12">
				<form
					onSubmit={evt => {
						evt.preventDefault();
						onSubmit({
							min: parseInt(minRef.current.value),
							max: parseInt(maxRef.current.value),
							label: labelRef.current.value,
							desc: descRef.current.value
						});
						minRef.current.value = "";
						maxRef.current.value = "";
						labelRef.current.value = "";
						descRef.current.value = "";
					}}
				>
					<div className="form-row">
						<div className="col">
							<label htmlFor="min-score-id">Min Score *</label>
							<input
								type="number"
								min="0"
								id="min-score-id"
								name="min-score-id"
								ref={minRef}
								required
								className="form-control input-height"
								placeholder="min score"
							/>
						</div>

						<div className="col">
							<label htmlFor="max-score-id">Max Score *</label>
							<input
								type="number"
								id="max-score-id"
								name="max-score-id"
								min="0"
								ref={maxRef}
								required
								className="form-control input-height"
								placeholder="max score"
							/>
						</div>
						<div className="col">
							<label htmlFor="color-score-id">Color*</label>
							<input
								type="text"
								id="color-score-id"
								name="color-score-id"
								ref={labelRef}
								required
								className="form-control input-height"
								placeholder="eg: green, red, or yellow"
							/>
						</div>
					</div>
					<div className="form-row">
						<div className="col-8">
							<label htmlFor="desc-score-id">
								Score Description*
							</label>
							<input
								type="text"
								id="desc-score-id"
								name="desc-score-id"
								ref={descRef}
								required
								className="form-control input-height"
								placeholder="enter score description"
							/>
						</div>

						<div className="col">
							<button
								type="submit"
								className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 m-t-20 btn-circle btn-success"
							>
								Add
								<i className="material-icons">
									arrow_right_alt
								</i>
							</button>
						</div>
					</div>
				</form>
			</div>
			<div className="col-md-12 m-t-20">
				<hr />
				<h4 className="text-success">Score Guides</h4>
				{items.map((a, i) => (
					<div key={i} className={`alert ${a.label}`}>
						<strong>
							{a.min} - {a.max}{" "}
						</strong>
						<span>{a.desc}</span>
					</div>
				))}
				{!items.length && (
					<h4 className="text-pink">No score guide added yet!</h4>
				)}
			</div>
		</div>
	);
}

export default ScoreGuide;
